const API_BASE_URL = 'https://portal.cehub.syngenta-ais.com/';
// const API_PUBLIC_URL = 'https://cehubservices.syngenta-ais.com/';
const API_PUBLIC_URL = 'https://services.cehub.syngenta-ais.com/';
const API_VISUALIZATION_URL = 'https://visualization.cehub.syngenta-ais.com';
const API_LOCAL_URL = 'https://localhost:7178/';
const TIME_OUT = 600000;
const TEST_TITLE = 'this is production title';

export {
    API_BASE_URL,
    API_PUBLIC_URL,
    API_VISUALIZATION_URL,
    API_LOCAL_URL,
    TIME_OUT,
    TEST_TITLE
};
